// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1734c442] .form-row .form-row-inner-container{grid-template-columns:3.35rem 8rem}[data-v-1734c442] .multisig_ban_container{padding-left:.7rem;width:11.35rem}[data-v-1734c442] .multisig_ban_container .is_multisig{width:11.35rem}", ""]);
// Exports
module.exports = exports;
